<template>
<div>
  <div class="wistia_embed wistia_async_xrk6oe46qa">
    &nbsp;
  </div>

  <div
    id="spirituality"
    class="tbk-vid-embed"
  >
    <a
      id="dirt"
      class="embedded_video"
      href="#wistia_1v4dscfbes?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="water"
      class="embedded_video"
      href="#wistia_341ppu8174?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="sky"
      class="embedded_video"
      href="#wistia_55hxtttehy?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>
  </div>
</div>
</template>

<script>
import TbkVideoMixin from './TbkVideoMixin'

export default {
  mixins: [TbkVideoMixin],

  mounted() {
    this.tbk.loadCrossTime('xrk', 24, this.showSelect)
    this.tbk.loadCrossTime('1v4', 376, this.showSelect)
    this.tbk.loadCrossTime('341', 456, this.showSelect)
    this.tbk.loadCrossTime('55h', 523, this.showSelect)

    if (this.tbk.isMobile()) {
      _wq.push({
        '1v4': this.tbk.autoPlay,
        341: this.tbk.autoPlay,
        '55h': this.tbk.autoPlay
      })
    }
  },

  methods: {
    showSelect() {
      $('.tbk-vid-embed').show()
      this.tbk.hideMobileControls()
    }
  }
}
</script>

<style scoped lang="sass">
#spirituality
  display: none
  a
    text-decoration: none
#dirt
  position: absolute
  top: calc(100% * (0 / 360))
  left: calc(100% * (0 / 640))
  width: calc(100% * (213 / 640))
  height: calc(100% * (360 / 360))
#water
  position: absolute
  top: calc(100% * (0 / 360))
  left: calc(100% * (214 / 640))
  width: calc(100% * (213 / 640))
  height: calc(100% * (360 / 360))
#sky
  position: absolute
  top: calc(100% * (0 / 360))
  left: calc(100% * (426 / 640))
  width: calc(100% * (214 / 640))
  height: calc(100% * (360 / 360))

</style>
